export default __webpack_public_path__ + "static/media/sideTable.450ee478.svg";